import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { selectSlot } from './slot.vanilla.mjs';

const SelectSlot = forwardRef(
  ({ className: classNameFromProps, side, ...props }, forwardedRef) => {
    const className = classNames(selectSlot({ side }), classNameFromProps);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        "data-scope": "select",
        "data-part": "slot",
        className,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
SelectSlot.displayName = "Select.Slot";

export { SelectSlot };
//# sourceMappingURL=Slot.mjs.map
